import React from "react";
import { component_tool } from '../../../../tool'
import moment from 'moment'
let { WizDataTable, WizButton } = component_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = (api) => {
  return [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    },
    {
      title: "问卷标题",
      name: "title",
      searchItem: {},
      tableItem: {width: 300}
    },
    {
      title: "问卷类型",
      name: "type",
      searchItem: {
        type: 'select',
        initialValue: api.apiParams.type,
        disabled: api.apiParams.type === 2 ? true : false
      },
      dict: [
        { code: 0, codeName: '普通问卷' },
        { code: 1, codeName: '随堂问卷' },
        { code: 2, codeName: '回执问卷' },
        { code: 3, codeName: '满意度问卷' }
      ],
      tableItem: {
        width: 120
      }
    },
    {
      title: "问卷时间",
      name: "surveyDate",
      tableItem: {
        width: 300,
        render: (text, record) => {
          const { startDate, endDate } = record;
          let classDate = formatterDate(startDate) + " ~" + formatterDate(endDate);
          return classDate
        }
      },
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'survey/list',
    ...api
  }
}

const surveyTemp = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(api),
    rowkey: 'id',
    rowName: 'title',
    tableApi: tableApi(api)
  }
}

export default surveyTemp
